import { useState, useEffect, useRef } from "react";
import ReactDom from "react-dom";
import ICON_CLOSE_X_2 from "../../Assets/jsx/ICON_CLOSE_X_2";

const modalRoot = document.getElementById("modal-root");

const Modal = ({
  id = "",
  modalClass = "",
  modalSize = "md",
  onClose,
  isOpen,
  is_hide,
  children,
  ...restProps
}) => {
  const [fadeType, setFadeType] = useState(null);
  const background = useRef();

  const transitionEnd = (e) => {
    if (e.propertyName !== "opacity" || fadeType === "in") return;
    if (fadeType === "out") {
      onClose();
    }
  };

  const onEscKeyDown = (e) => {
    if (e.key !== "Escape") return;
    setFadeType("out");
  };

  const handleClick = (e) => {
    e.preventDefault();
    setFadeType("out");
  };

  useEffect(() => {
    window.addEventListener("keydown", onEscKeyDown, false);
    setTimeout(() => setFadeType("in"), 0);

    return () => {
      window.removeEventListener("keydown", onEscKeyDown, false);
    };
  }, []);

  useEffect(() => {
    setFadeType("out");
  }, [isOpen]);

  const getModalWidth = () => {
    switch (modalSize) {
      case "large":
        return "1200px";
      case "small":
        return "450px";
      case "medium":
        return "900px";
      case "full":
        return "calc( 100vw - 20px )";
      default:
        return "480px";
    }
  };

  const getModalMaxWidth = () => {
    switch (modalSize) {
      case "full":
        return "calc( 100vw - 20px )";
      default:
        return "calc( 100vw - 20px )";
    }
  };

  const getModalMaxHeight = () => {
    if (modalSize === "full") {
      if (is_hide) {
        return "calc( 100vh - 20px )";
      } else {
        return "100vh";
      }
    } else {
      return "calc( 100vh - 150px )";
    }
  };

  const getBoxBodyPadding = () => {
    switch (modalSize) {
      case "full":
        return "0px";
      default:
        return "0px 24px 0px 24px";
    }
  };

  const getBoxBodyHeight = () => {
    if (modalSize === "full") {
      if (is_hide) {
        return "calc( 100vh - 70px )";
      } else {
        return "calc( 100vh - 50px )";
      }
    } else {
      return "auto";
    }
  };

  const getBoxBodyPaddingBottom = () => {
    switch (modalSize) {
      case "full":
        return "0px";
      default:
        return "20px";
    }
  };

  const wrapperStyles = {
    position: "fixed",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    opacity: fadeType === "in" ? 1 : 0,
    zIndex: 3,
    width: getModalWidth(),
    maxWidth: getModalMaxWidth(),
    maxHeight: getModalMaxHeight(),
    boxSizing: "border-box",
    margin: "auto",
    WebkitTransition: "0.01s",
    MozTransition: "0.01s",
    OTransition: "0.01s",
    transition: "0.01s",
  };

  const backgroundStyles = {
    background: "rgba(255, 255, 255, 0)",
    position: "fixed",
    zIndex: 1040,
    display: "block",
    top: 0,
    left: 0,
    bottom: 0,
    right: 0,
    outline: 0,
  };

  const boxDialogStyles = {
    borderRadius: "18px",
    zIndex: 1050,
    width: "100%",
    position: "relative",
    backgroundColor: "rgba(255, 255, 255, 0.9)",
    backdropFilter: "blur(3px)",
    WebkitBackdropFilter: "blur(3px)",
    overflow: "hidden",
    border: "2px solid #6f6f6f",
  };

  const boxHeaderStyles = {
    textAlign: "right",
    paddingTop: "5px",
    paddingRight: "5px",
    position: "relative",
    zIndex: 1052,
  };

  const boxBodyStyles = {
    boxSizing: "border-box",
    overflowY: "auto",
    overflowX: "hidden",
    padding: getBoxBodyPadding(),
    maxHeight: getModalMaxHeight(),
    height: getBoxBodyHeight(),
    paddingBottom: getBoxBodyPaddingBottom(),
    position: "relative",
    zIndex: 1051,
    backgroundColor: "transparent",
  };

  return ReactDom.createPortal(
    <div
      id={id}
      className={`wrapper size-${modalSize} fade-${fadeType} ${modalClass}`}
      role="dialog"
      style={wrapperStyles}
      onTransitionEnd={transitionEnd}
      {...restProps}
    >
      <div style={boxDialogStyles}>
        <div style={boxHeaderStyles}>
          {is_hide !== "hide" ? (
            <button
              onClick={handleClick}
              className="close_button background_black"
              data-mapid="clickTutup"
            >
              <ICON_CLOSE_X_2
                color="#fff"
                style={{
                  width: "15px",
                }}
              />
            </button>
          ) : null}
        </div>
        <div style={boxBodyStyles}>{children}</div>
      </div>
      <div
        style={backgroundStyles}
        onMouseDown={handleClick}
        ref={background}
      />
    </div>,
    modalRoot
  );
};

export default Modal;
